import * as React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

import { IconProps } from '../icons'

const DayFilled = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <G clipPath="url(#a)">
      <Path
        d="M3.12 10.6v6.55c0 1.89 1.55 3.44 3.44 3.44h10.88c1.89 0 3.44-1.55 3.44-3.44V10.6H3.12Zm6.68 3.54c0 .47-.39.86-.86.86H7.06c-.47 0-.86-.39-.86-.86v-1.28c0-.47.39-.86.86-.86h1.88c.47 0 .86.39.86.86v1.28Z"
        fill={color}
      />
      <Path
        d="M17.44 5.32h-.78v-1.3c0-.44-.36-.8-.8-.8-.44 0-.8.36-.8.8v1.3H8.81v-1.3c0-.44-.36-.8-.8-.8-.44 0-.8.36-.8.8v1.3h-.64c-1.89 0-3.44 1.55-3.44 3.44V9h17.75v-.24c0-1.89-1.55-3.44-3.44-3.44Z"
        fill={color}
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default DayFilled
